import * as React from 'react';
import { pluralize } from '@cian/newbuilding-utils';
import { IconHouse16, InlineText1, InlineText2 } from '@cian/ui-kit';
import { IHouse } from '../../types/newbuilding/house';

import * as styles from './styles.css';
import { createHouseLink } from './utils';

interface IEscrowHousesProps {
  houses: IHouse[];
  newbuildingId: number;
  onClick(): void;
}

export const EscrowHouses = ({ houses, newbuildingId, onClick }: IEscrowHousesProps) => {
  return (
    <div>
      {houses.map(house => {
        return (
          <div className={styles['row']} key={house.houseId}>
            <div className={styles['img']}>
              <IconHouse16 />
            </div>
            <div className={styles['name']}>
              <InlineText1 fontWeight="700">{house.houseName}</InlineText1>
            </div>
            <div className={styles['status']}>
              <InlineText2 color="gray60_100">{house.finishStatus}</InlineText2>
            </div>
            <div className={styles['offers']}>
              {house.fromDeveloperPropsCount ? (
                <a
                  className={styles['link']}
                  href={createHouseLink({ houseId: house.houseId, newbuildingId })}
                  onClick={onClick}
                >
                  {pluralize(house.fromDeveloperPropsCount, ['предложение', 'предложения', 'предложений'])}
                </a>
              ) : (
                <InlineText2>нет предложений</InlineText2>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};
